import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
// material
import {
  Card,
  Stack,
  Container,
  Typography,
  Tooltip,
  IconButton,
  Grid,
  TextField,
  Button,
  DialogContent,
  Dialog,
  Box,
  DialogTitle
} from "@mui/material";
import Page from "../components/Page";
import Select from "react-select";
import { useLocation, useNavigate } from "react-router-dom";
import { Check, DeleteSharp, RemoveRedEye } from "@mui/icons-material";
import CloseIcon from "@mui/icons-material/Close";
import {
  fetchallcitylist,
  fetchchapterbyuser,
  fetchThankYouNoteWaitingsForApprovalList
} from "src/utils/common";
import { CSVLink } from "react-csv";
import { approvedThankyouNoteRequest, deleteThankyouNoteRequest } from "src/api/commonapi";
import { notification } from "src/utils/messages";
import Deletemodal from "./DeleteModal";
import DatePicker from "@mui/lab/DatePicker";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import moment from "moment";
import { Routes } from "src/constant/api_url";
import CustomLoader from "src/commonComponents/CustomLoader";
import ConfirmModal from "./ConfirmModal";
import { saveAs } from "file-saver";
import DownloadIcon from "@mui/icons-material/Download";

const ThankyouNoteApproval = () => {
  let loginUser = JSON.parse(localStorage.getItem("userData"));
  const location = useLocation();
  const navigate = useNavigate();
  const [businessData, setBusinessData] = useState([]);
  const [newBusinessData, setNewBusinessData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [dvisible, setDvisible] = useState({ mval: false, id: 0 });
  const [dvisible2, setDvisible2] = useState({ mval: false, id: 0 });
  const [openImageModal, setOpenImageModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState([]);
  const [filterBusiness, setFilterBusiness] = useState({
    city_id:
      loginUser?.u_type == 1 ||
        (loginUser?.u_type == 2 && loginUser?.p_user_id != 1 && loginUser?.management_p == 1)
        ? loginUser?.city_id
        : location.state?.city || 0,

    chpt_id: 0,

    search: "",
    s_date: null,
    e_date: null
  });
  const filterData = () => {
    const isWithinDateRange = (date) =>
      filterBusiness.e_date &&
      filterBusiness.s_date &&
      moment(date, "DD-MM-YYYY").isBetween(
        filterBusiness.s_date,
        filterBusiness.e_date,
        "days",
        "[]"
      );

    const matchesSearchTerm = (business) => {
      const searchTerm = filterBusiness.search.toLowerCase();
      return (
        business.Given.toLowerCase().includes(searchTerm) ||
        business.Receiver.toLowerCase().includes(searchTerm) ||
        business.b_amount.toString().toLowerCase().includes(searchTerm) ||
        business.b_thanksnote.toLowerCase().includes(searchTerm)
      );
    };

    const matchesChapterId = (business) => {
      if (filterBusiness.chpt_id != 0 || filterBusiness.city_id != 0) {
        if (filterBusiness.chpt_id != 0) {
          return (
            business.c1_chpt_id === filterBusiness.chpt_id ||
            business.c2_chpt_id === filterBusiness.chpt_id
          );
          //
        } else if (filterBusiness.city != 0) {
          const cityChapters = chaptlist
            .filter((chapter) => chapter.city_id === filterBusiness.city_id)
            .map((chapter) => chapter.chpt_id);

          return (
            cityChapters.includes(business.c1_chpt_id) || cityChapters.includes(business.c2_chpt_id)
          );
        }
      } else return true;
    };

    const nbusinessData =
      businessData?.filter(
        (business) =>
          (isWithinDateRange(business.b_date) ||
            !filterBusiness.e_date ||
            !filterBusiness.s_date) &&
          matchesSearchTerm(business) &&
          matchesChapterId(business)
      ) || [];

    setNewBusinessData(nbusinessData);
  };

  useEffect(async () => {
    if (filterBusiness.search != undefined) {
      await filterData();
    }
  }, [filterBusiness, businessData]);

  useEffect(() => {
    getBusinessList();
  }, []);
  const getBusinessList = async () => {
    setIsLoading(true);
    setBusinessData(await fetchThankYouNoteWaitingsForApprovalList(loginUser?.city_id));
    setIsLoading(false);
  };

  const editThankYouNote = async (id) => {
    const resp = await approvedThankyouNoteRequest(id);
    let notify = notification({
      type: resp.status == 0 ? "error" : "success",
      message: resp.message
    });
    notify();
    if (resp.status == 1) {
      getBusinessList();
      setDvisible2({ mval: false, id: 0 });
    }
  };
  const deleteThankYouNote = async (id) => {
    const resp = await deleteThankyouNoteRequest(id);
    let notify = notification({
      type: resp.status == 0 ? "error" : "success",
      message: resp.message
    });
    notify();
    if (resp.status == 1) {
      setDvisible({ mval: false, id: 0 });
      getBusinessList();
    }
  };
  const columns = [
    {
      name: "No",
      wrap: true,
      selector: (row, key) => row?.b_w_id,
      width: "100px",
      sortable: true
    },

    {
      name: "Receive",
      wrap: true,
      selector: (row) => row?.Receiver,
      sortable: true
    },
    {
      name: "Giver",
      wrap: true,
      selector: (row) => row?.Given,
      sortable: true
    },
    {
      name: "Amount",
      wrap: true,
      selector: (row) => row?.b_amount,
      width: "150px",

      sortable: true
    },
    {
      name: "Date",
      wrap: true,
      selector: (row) => row?.b_date,
      width: "120px",
      sortable: true
    },
    {
      name: "Comment ",
      wrap: true,
      selector: (row) => row?.b_thanksnote,
      sortable: true
    },
    {
      name: "Image ",
      wrap: true,
      selector: (row) => (
        <>
          {row?.thanksnote_image?.length > 0 && (
            <Tooltip title="View Image">
              <IconButton
                onClick={() => {
                  setSelectedImage(row.thanksnote_image); // store image
                  setOpenImageModal(true); // open modal
                }}
              >
                <RemoveRedEye color="info" />
              </IconButton>
            </Tooltip>
          )}
        </>
      )
    },

    {
      name: "Action",
      wrap: true,
      sortable: true,
      width: "120px",
      selector: (row) => (
        <>
          <Tooltip title="Approve Thankyou Note">
            <IconButton
              onClick={() => {
                setDvisible2({ mval: true, id: row.b_w_id });
                // getBusinnesAmount(row.b_amount, row.b_id);
              }}
            >
              <Check color="success" />
            </IconButton>
          </Tooltip>
          <Tooltip title="Remove Thankyou Note">
            <IconButton
              onClick={() => {
                // deleteThankYouNote;
                setDvisible({ mval: true, id: row.b_w_id });
              }}
            >
              <DeleteSharp color="error" />
            </IconButton>
          </Tooltip>
        </>
      )
    }
  ];
  const expo_columns = [
    { label: "No", key: "b_w_id" },
    { label: "Receive", key: "Receive" },
    { label: "Giver", key: "Given" },
    { label: "Date", key: "b_date" },
    { label: "Amount", key: "b_amount" },
    { label: "Thankyou Note", key: "b_thanksnote" }
  ];

  const [citylist, setcitylist] = useState([]);

  const getallcitylist = async () => {
    setcitylist(await fetchallcitylist());
  };
  useEffect(async () => {
    getallcitylist();
    setchaplist(await fetchchapterbyuser(loginUser.city_id, loginUser.u_type));
  }, []);

  const [chaptlist, setchaplist] = useState([]);

  return (
    <>
      <ConfirmModal
        visible={dvisible2}
        setVisible={setDvisible2}
        fun={editThankYouNote}
        title={"Are You Sure You Want To Approve"}
      />
      <Deletemodal visible={dvisible} setVisible={setDvisible} deletefunc={deleteThankYouNote} />
      <Page title="Business Approval | Local Vocal Business Group">
        <Container>
          <Stack direction="row" alignItems="center" justifyContent="space-between" mb={1}>
            <Typography variant="h4" gutterBottom>
              Thankyou Note Approval List
            </Typography>
          </Stack>

          <Card className="p-20">
            <Grid container spacing={2} sx={{ display: "flex", alignItems: "flex-end" }}>
              <Grid item xs={2}>
                <Stack>
                  <label>Select City</label>
                  <Select
                    menuPortalTarget={document.body}
                    isDisabled={
                      loginUser?.u_type == 1 ||
                        (loginUser?.u_type == 2 &&
                          loginUser?.p_user_id != 1 &&
                          loginUser?.management_p == 1)
                        ? true
                        : false
                    }
                    options={[
                      {
                        value: 0,
                        label: "All City"
                      },
                      ...citylist.map((city) => {
                        return {
                          label: city?.city_name,
                          value: city?.city_id
                        };
                      })
                    ]}
                    onChange={(e) => {
                      setFilterBusiness({
                        ...filterBusiness,
                        city_id: e.value,
                        chpt_id: 0
                      });
                    }}
                    value={
                      filterBusiness.city_id == 0
                        ? {
                          value: 0,
                          label: "All City"
                        }
                        : citylist.map((city) => {
                          return (
                            filterBusiness.city_id == city.city_id && {
                              value: city.city_id,
                              label: city.city_name
                            }
                          );
                        })
                    }
                  />
                </Stack>
              </Grid>
              <Grid item xs={2}>
                <Stack spacing={3}>
                  <label>Select Chapter</label>
                  <Select
                    name="chpt_id"
                    menuPortalTarget={document.body}
                    onChange={(e) => {
                      setFilterBusiness({
                        ...filterBusiness,
                        chpt_id: e.value
                      });
                    }}
                    options={[
                      {
                        value: 0,
                        label: "All Chapter"
                      },
                      ...(chaptlist &&
                        chaptlist
                          ?.map((chpt) => {
                            if (filterBusiness?.city_id != 0) {
                              if (filterBusiness?.city_id == chpt?.city_id) {
                                return {
                                  value: chpt.chpt_id,
                                  label: chpt.chpt_name
                                };
                              }
                            } else {
                              return {
                                value: chpt.chpt_id,
                                label: chpt.chpt_name
                              };
                            }
                          })
                          .filter((f) => f != undefined))
                    ]}
                    value={
                      filterBusiness.chpt_id == 0
                        ? { value: 0, label: "All Chapter" }
                        : chaptlist &&
                        chaptlist.map((c) => {
                          if (c.chpt_id == filterBusiness.chpt_id) {
                            return {
                              value: c.chpt_id,
                              label: c.chpt_name
                            };
                          }
                        })
                    }
                  />
                </Stack>
              </Grid>
              <Grid item xs={3}>
                <Stack spacing={10}>
                  <TextField
                    style={{ marginTop: "0px" }}
                    fullWidth
                    autoComplete="off"
                    type="text"
                    label="Search"
                    name="name"
                    size="small"
                    autoCorrect="off"
                    value={filterBusiness.search || ""}
                    onChange={(e) => {
                      setFilterBusiness({
                        ...filterBusiness,
                        search: e.target.value
                      });
                    }}
                  />
                </Stack>
              </Grid>
              <Grid item xs={5}>
                <div
                  className="d-flex"
                  style={{
                    alignItems: "center",
                    justifyContent: "space-between"
                  }}
                >
                  <Stack spacing={10} sx={{ marginRight: "5px" }}>
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                      <DatePicker
                        type="date"
                        name="s_date"
                        label="Start Date"
                        value={
                          filterBusiness?.s_date != undefined
                            ? moment(filterBusiness.s_date, "DD-MM-YYYY")
                            : null
                        }
                        inputFormat="dd/MM/yyyy"
                        onChange={(newDate) => {
                          setFilterBusiness({
                            ...filterBusiness,
                            s_date: newDate
                          });
                        }}
                        renderInput={(params) => <TextField {...params} size="small" />}
                      />
                    </LocalizationProvider>
                  </Stack>

                  <Stack spacing={10} sx={{ marginRight: "5px" }}>
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                      <DatePicker
                        type="date"
                        name="e_date"
                        label="End Date"
                        value={
                          filterBusiness?.e_date != undefined
                            ? moment(filterBusiness.e_date, "DD-MM-YYYY")
                            : null
                        }
                        inputFormat="dd/MM/yyyy"
                        onChange={(newDate) => {
                          setFilterBusiness({
                            ...filterBusiness,
                            e_date: newDate
                          });
                        }}
                        renderInput={(params) => <TextField {...params} size="small" />}
                      />
                    </LocalizationProvider>
                  </Stack>

                  <Stack spacing={10} sx={{ marginRight: "5px" }}>
                    <Button
                      onClick={async () => {
                        setFilterBusiness({
                          city_id:
                            loginUser?.u_type == 1 ||
                              (loginUser?.u_type == 2 &&
                                loginUser?.p_user_id != 1 &&
                                loginUser?.management_p == 1)
                              ? loginUser?.city_id
                              : 0,
                          chpt_id: 0,
                          search: "",
                          s_date: null,
                          e_date: null
                        });
                      }}
                      variant="contained"
                    >
                      clear
                    </Button>
                  </Stack>
                </div>
              </Grid>
            </Grid>
          </Card>

          <Card className=" p-20" style={{ marginTop: "15px" }}>
            {newBusinessData && newBusinessData?.length != 0 && (
              <Button className="btn btn-export">
                <CSVLink
                  data={newBusinessData}
                  headers={expo_columns}
                  filename={"ThankYou Note Approval List.csv"}
                  className="btn btn-primary test"
                  target="_blank"
                >
                  Export CSV
                </CSVLink>
              </Button>
            )}

            <DataTable
              style={{ overflow: "hidden" }}
              filter
              pagination
              highlightOnHover
              columns={columns}
              data={newBusinessData && newBusinessData?.length != 0 ? newBusinessData : []}
              progressPending={isLoading}
              progressComponent={<CustomLoader />}
            />
          </Card>
        </Container>
      </Page>
      <Dialog
        open={openImageModal}
        onClose={() => setOpenImageModal(false)}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: "10px",
            overflow: "hidden",
            border: "4px solid #fff"
          }
        }}
      >
        <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Typography variant="h6">View Images</Typography>
          <IconButton onClick={() => setOpenImageModal(false)}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          <Grid container spacing={2}>
            {selectedImage && selectedImage.length > 0 ? (
              selectedImage.map((img, index) => (
                <Grid item xs={12} key={index} sx={{ position: "relative", textAlign: 'center' }}>
                  <Box sx={{ position: 'relative', display: 'inline-block', width: '100%' }}>
                    <IconButton
                      onClick={() => {
                        saveAs(`${Routes.API_HOSTNAME}thanksnote-image/${img.url}`, img.url);
                      }}
                      sx={{
                        position: "absolute",
                        top: 8,
                        right: 8,
                        zIndex: 1,
                        backgroundColor: "error.main",
                        color: "#fff",
                        "&:hover": {
                          backgroundColor: "error.dark"
                        }
                      }}
                    >
                      <DownloadIcon fontSize="small" />
                    </IconButton>
                    <img
                      src={`${Routes.API_HOSTNAME}thanksnote-image/${img.url}`}
                      alt={`Thanks Note ${index + 1}`}
                      style={{
                        width: "100%",
                        display: "block",
                        maxHeight: "450px",
                        objectFit: "contain",
                        borderRadius: "8px"
                      }}
                    />
                  </Box>
                </Grid>
              ))
            ) : (
              <Grid item xs={12}>
                <Typography variant="body2" textAlign="center">No images available</Typography>
              </Grid>
            )}
          </Grid>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default ThankyouNoteApproval;
